// extracted by mini-css-extract-plugin
export default {"container":"Login_container__VMeB7","form":"Login_form__UohUC","logo":"Login_logo__W+opJ","submit":"Login_submit__glxzR"};